<template>
  <div :class="['motorcontrols', { 'motorcontrols--disabled': disabled }]">
    <div
      class="motorcontrols__arrow-up"
      @click="$emit('clickUp')"
      @mousedown="startSending('holdUp')"
      @touchstart="startSending('holdUp')"
      @mouseup="stopSending"
      @mouseleave="stopSending"
      @mouseout="stopSending"
      @touchcancel="stopSending"
      @touchend="stopSending"
    ></div>
    <div
      class="motorcontrols__arrow-left"
      @click="$emit('clickLeft')"
      @mousedown="startSending('holdLeft')"
      @touchstart="startSending('holdLeft')"
      @mouseup="stopSending"
      @mouseleave="stopSending"
      @mouseout="stopSending"
      @touchcancel="stopSending"
      @touchend="stopSending"
    ></div>
    <div
      class="motorcontrols__arrow-right"
      @click="$emit('clickRight')"
      @mousedown="startSending('holdRight')"
      @touchstart="startSending('holdRight')"
      @mouseup="stopSending"
      @mouseleave="stopSending"
      @mouseout="stopSending"
      @touchcancel="stopSending"
      @touchend="stopSending"
    ></div>
    <div
      class="motorcontrols__arrow-down"
      @click="$emit('clickDown')"
      @mousedown="startSending('holdDown')"
      @touchstart="startSending('holdDown')"
      @mouseup="stopSending"
      @mouseleave="stopSending"
      @mouseout="stopSending"
      @touchcancel="stopSending"
      @touchend="stopSending"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

onMounted(() => {
  window.addEventListener(
    'mouseup',
    () => {
      stopSending()
    },
    false,
  )
  window.addEventListener(
    'touchend',
    () => {
      stopSending()
    },
    false,
  )
})

const emit = defineEmits([
  'clickUp',
  'clickDown',
  'clickLeft',
  'clickRight',
  'holdUp',
  'holdDown',
  'holdLeft',
  'holdRight',
])

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

const intervalId = ref()

const startSending = (
  eventName: 'holdUp' | 'holdDown' | 'holdLeft' | 'holdRight',
) => {
  // Clear any existing interval
  stopSending()

  // Start a new interval that triggers the send message method every fifth of a second

  intervalId.value = setInterval(() => {
    emitEvent(eventName)
  }, 200)
}

const emitEvent = (
  eventName: 'holdUp' | 'holdDown' | 'holdLeft' | 'holdRight',
) => {
  emit(eventName)
}

const stopSending = () => {
  // Clear the interval
  clearInterval(intervalId.value)
}
</script>

<style lang="scss" scoped>
.motorcontrols {
  position: relative;
  width: 100px;
  max-width: 100%;
  aspect-ratio: 1;

  &--disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  div[class*='motorcontrols__'] {
    height: 45%;
    width: 45%;
    position: absolute;
    background-image: url('@/assets/arrow.svg');
    background-size: contain;
    background-repeat: no-repeat;
    transition: 0.3s;

    &:hover {
      background-image: url('@/assets/arrow-filled.svg');
    }

    &:active {
      background-image: url('@/assets/arrow-pressed.svg');
    }
  }

  &__arrow-up {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &__arrow-down {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%) rotate(180deg);
  }

  &__arrow-left {
    left: 0;
    top: 50%;
    transform: translateY(-50%) rotate(270deg);
  }

  &__arrow-right {
    right: 0;
    top: 50%;
    transform: translateY(-50%) rotate(90deg);
  }
}
</style>
